import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header5 from "../../components/header/Header5";
import Footer3 from "../../components/footer3";
import Gotop from "../../components/gotop";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumbastrologer from "../../components/breadcrumbastrologer";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import "../../assets/Spinner.css";
import defaultPic from "../../assets/siteimages/favicon.png"; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

DashboardAstroPhotograph.propTypes = {};

function DashboardAstroPhotograph(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

   const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  
  

  const { logout } = useContext(AuthContext);

  
  const [astrologerId, setAstrologerId] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [status, setStatus] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [astrologerStatus, setAstrologerStatus] = useState({ Named: "", Id: "" });
const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    const storedUserId = localStorage.getItem("astrologerId");
    if (storedUserId) {
      setAstrologerId(storedUserId);

      // Check if photograph already submitted
      axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/check-photo-status/${storedUserId}`)
        .then(res => {
          if (res.data.Aphotograph !== "1") {
            setShowForm(true);
          }
        })
        .catch(err => console.error("Error checking photo status:", err));
    }
  }, []);

  useEffect(() => {
    const fetchAstrologer = async () => {
      try {
        const res = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getastrologerbyidprofile/${astrologerId}`);
        if (res.data) {
          setAstrologerStatus({
            Named: res.data.Named,
            Id: res.data.Id,
            Path1: res.data.Path1,
          });
        }
      } catch (err) {
        console.error("Error fetching astrologer:", err);
      }
    };

    if (astrologerId) {
      fetchAstrologer();
    }
  }, [astrologerId]);
const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!photo) {
     toast.error("Please select a photo.");
    return;
  }

  setIsSubmitting(true); // Disable the button

  const formDataToSend = new FormData();
  formDataToSend.append("photo", photo);
  formDataToSend.append("astrologerId", astrologerId);

  try {
    const res = await axios.post(
      "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/upload-photo",
      formDataToSend
    );
     toast.success("Profile Picture Updated Successfully!");

    // Redirect after short delay
    setTimeout(() => {
      window.location.href = "/completeprofile";
    }, 5000);
  } catch (err) {
    console.error(err);
     toast.error("Upload failed.");
    setIsSubmitting(false); // Re-enable on failure
  }
};

  const imageSrc = astrologerStatus.Path1 ? astrologerStatus.Path1 : defaultPic;
  return (
    <>
    <Helmet>
            <title>Update Your Profile Picture - Adhigyanam | Sauntesthyam LLP</title>
          </Helmet>
        
        <Breadcrumbastrologer title="Update Your Profile Picture" />

         <section className="account-section" style={{backgroundColor:"#fafafa"}}>
                      <div className="tf-container">
                        <div className="row">
                          <div className="wd-form-login">
                          <div style={{ textAlign: "center", maxWidth:"300px", margin:"auto", marginTop: "20px" }}>
                               <img
                                 src={imageSrc}
                                 alt="Astrologer"
                                 style={{ width: "100px", height: "100px", borderRadius: "50%", padding:"5px", border:"solid #f2f2f2 2px" }}
                               />
                             </div>
                          <h5 style={{fontSize:"27px"}}>Update Your Profile Picture</h5>
                          <p style={{marginBottom:"20px"}}>Use the following control to update your profile picture.</p>
                           
                             

                              {showForm ? (
        <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="ip">
          <input
  type="file"
  accept="image/*"
  onChange={(e) => {
    const file = e.target.files[0];
    setPhoto(file);
    if (file) {
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl(null);
    }
  }}
  required
/>
{previewUrl && (
  <div style={{ marginTop: "10px" }}>
    <p style={{ marginBottom: "6px" }}>Quick Preview</p>
    <img src={previewUrl} alt="Preview" style={{ maxWidth: "100%", height: "auto", border: "1px solid #ccc", borderRadius: "8px" }} />
  </div>
)}
          </div>
         <button type="submit" disabled={isSubmitting}>
  {isSubmitting ? "Please Wait..." : "Submit Photograph"}
</button>
          {status && <p style={{ color: "green", marginTop: "10px" }}>{status}</p>}
        </form>
        
      ) : (
        <p style={{ color: "green", fontWeight: "bold" }}>
          ✅ Profile Picture Updated.
        </p>
      )}
          <style>
{`
  .Toastify__close-button {
    display: none;
  }

  .Toastify__toast {
    position: relative;
    padding-right: 30px;
  }
`}
</style>
           <ToastContainer position="bottom-center"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover />                   


                                <div className="group-ant-choice" style={{marginTop:"15px", textAlign:"center"}}>
                                                                                   
                                                                                   <Link to="/completeprofile" className="forgot" style={{margin:"auto"}}>
                                                                                                                                                                  Return To Verification Desk
                                                                                                                                                                </Link>
                                                                                  </div>
                           
                          </div>
                        </div>
                      </div>
                    </section>
       
       
        <div
                  className="floating-buttons"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    left: "20px",
                    zIndex: "1000",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {/* Call Button */}
                  <a
                    href={`tel:+918960708425`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#007BFF",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaPhoneAlt />
                  </a>
                
                  {/* WhatsApp Button */}
                  <a
                    href={`https://wa.me/918960708425`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#25D366",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaWhatsapp />
                  </a>
                </div>
    
      <Gotop />
    </>
  );
}

export default DashboardAstroPhotograph;
